import { Empty as AntEmpty, EmptyProps } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const Empty = (props: EmptyProps) => {
    const { t } = useTranslation();

    return (
        <StyledEmpty
            description={t('Empty.Description')}
            image={null}
            {...props}
        />
    );
};

const StyledEmpty = styled(AntEmpty)`
    .ant-empty-image {
        display: none;
    }
`;
